import React from 'react';

interface DisabledMarketingPopupProps {
  onClose: () => void;
  onRequestDemo: () => void;
}

export const DisabledMarketingPopup: React.FC<DisabledMarketingPopupProps> = ({
  onClose,
  onRequestDemo
}) => {
  return (
    <div className="disabled-marketing-popup-overlay">
      <div className="disabled-marketing-popup">
        <button className="disabled-marketing-popup__close" onClick={onClose}>✕</button>

        <div className="disabled-marketing-popup__icon">🎨</div>

        <h2 className="disabled-marketing-popup__title">
          Marketing Mode - Coming Soon
        </h2>

        <div className="disabled-marketing-popup__content">
          <p>
            The professional Marketing Mode allows you to create high-quality captures
            for your marketing:
          </p>

          <ul className="disabled-marketing-popup__features">
            <li>
              <span className="feature-icon">📸</span>
              <span>Professional photo and video captures</span>
            </li>
            <li>
              <span className="feature-icon">🎛️</span>
              <span>Control views, furniture and lighting</span>
            </li>
            <li>
              <span className="feature-icon">🎥</span>
              <span>Adjustable focal length and camera settings</span>
            </li>
            <li>
              <span className="feature-icon">✨</span>
              <span>Plaza AI Editor for image optimization</span>
            </li>
            <li>
              <span className="feature-icon">🚁</span>
              <span>Multiple navigation modes (building, tour, drone)</span>
            </li>
          </ul>

          <p className="disabled-marketing-popup__cta-text">
            Interested in early access? Contact us for a demo!
          </p>
        </div>

        <div className="disabled-marketing-popup__actions">
          <button
            className="disabled-marketing-popup__demo-button"
            onClick={onRequestDemo}
          >
            Request Demo
          </button>
        </div>
      </div>
    </div>
  );
};
